module.exports = __webpack_public_path__ + "img/104081.6c543e05.png";